export default "__VITE_IMAGE_ASSET__dc6c6253__";